export default {
  PRIMARY: '#08B2E3',
  INFO: '#484D6D',
  SUCCESS: '#57A773',
  DANGER: '#EE6352',
  WARNING: '#F5CB5C',
  DEFAULT: '#181826',
  SECONDARY: '#EFE9F4',
}
